import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Carousel from 'srcReact/components/common2/Carousel'
import CarouselDateCard from 'srcReact/components/common2/CarouselDateCard'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import styles from './styles.module.scss'
import history, { redirectToPage, redirectToBack } from 'srcReact/helpers/history'
import { urlSearchParams } from 'srcReact/helpers/utils'
import IconButton from 'srcReact/components/common2/IconButton'
import BackNavigation from 'srcReact/components/common2/BackNavigation'

export default function RecurringMixrs({
  recurrence,
  currentMixrId,
  options = [],
  isSuspended,
  isStatic,
  isPreview,
  isActive
}) {
  const { t } = useTranslation()
  const {
    common: { isMobile, isTablet, isNative, isDesktop },
    mixr: { mixr }
  } = useSelector((state) => state)

  const [isBackButton] = useState(
    isNative
      ? urlSearchParams('backNavigation')
      : (history.location.state && history.location.state.backNavigation) || false
  )

  const handleBack = () => {
    if (!isPreview) {
      const isBackInUrl = history.location.pathname.includes('backNavigation')
      if (isBackButton || isBackInUrl) {
        redirectToBack(isNative)
      } else {
        redirectToPage(`/0/myhome`, isNative)
      }
    }
  }

  const handleCarouselChange = (data) => {
    if (!isPreview && isMobile && data && data.item) {
      const { mixrId } = data.item
      redirectToPage(`/0/home/event/${mixrId}`, isNative)
    }
  }

  return (
    <div className={`${styles.recurringContainer} ${isPreview && styles.recurringContainerWithPreview}`}>
      <BackNavigation
        theme={isMobile || isNative ? 'lightblue' : 'gray'}
        customHandleBack={handleBack}
        iconSize={'large24'}
      />
      <div className={styles.center}>
        {recurrence && recurrence.type !== 'none' && recurrence.events?.length > 0 && (
          <Carousel
            onChange={handleCarouselChange}
            itemsToShow={5}
            breakPoints={[
              isDesktop
                ? { width: 1, itemsToShow: 5, itemsToScroll: 5 }
                : isTablet
                ? { width: 1, itemsToShow: 3, itemsToScroll: 3 }
                : isMobile
                ? { width: 1, itemsToShow: 1, itemsToScroll: 1 }
                : { width: 1, itemsToShow: 5, itemsToScroll: 5 }
            ]}
            itemsToSroll={4}
            initialActive={recurrence.events
              .filter((e) => e.status !== 'cancelled')
              .findIndex((x) => x.id == currentMixrId)}
            className={styles.carouselWrapper}
            itemPadding={[0, 0]}>
            {recurrence.events.map((event, i) => {
              return event.status !== 'cancelled' ? (
                <CarouselDateCard
                  key={event.id}
                  date={event.local_start_at || (isStatic && event.start_at)}
                  mixrId={event.id}
                  selected={currentMixrId == event.id}
                  isStatic={isStatic || isPreview}
                />
              ) : null
            })}
          </Carousel>
        )}
      </div>
      {mixr && (isMobile || isTablet || isNative) && !isDesktop && !isSuspended && (
        <div className={styles.right}>
          {isActive && (
            <IconButton
              iconName='add-contact'
              iconSize='large32'
              className={styles.inviteButton}
              onClick={() => redirectToPage(`/0/event/${mixr.id}/invite-members`, isNative)}
            />
          )}

          <ReactMenu
            isStatic={isPreview}
            options={options}
            menuButtonCSS={styles.moreOptions}
            menuCSS={styles.moreOptionsMenu}
          />
        </div>
      )}
    </div>
  )
}
